import { render, staticRenderFns } from "./plotTreeScript.vue?vue&type=template&id=58b9e0b1&scoped=true"
import script from "./plotTreeScript.vue?vue&type=script&lang=js"
export * from "./plotTreeScript.vue?vue&type=script&lang=js"
import style0 from "./plotTreeScript.vue?vue&type=style&index=0&id=58b9e0b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b9e0b1",
  null
  
)

export default component.exports